<template>
    <div class="d-flex flex-column align-items-center justify-content-center">
        <alert-success :form="form" message="We have e-mailed your password reset link!" :class="'shadow-sm'" :style="'width: -webkit-fill-available'"></alert-success>

        <div class="wd-150 wd-sm-150 mg-b-30">
            <img :src="padlock" class="img-fluid" alt="">
        </div>

        <h4 class="tx-20 tx-sm-24 tx-center">Reset your password</h4>
        <p class="tx-color-03 mg-b-30 tx-center">Please enter the email address that you registered with. We will send you a link for setting a new password. If you do not receive an email, please check your spam folder.</p>
        
        <form method="POST" action="/password/email" @submit.prevent="sendEmail" class="wd-100p">
            <div class="wd-100p d-flex flex-column flex-sm-row">
                <input v-model="form.email" type="email" class="form-control wd-sm-250 flex-fill shadow-sm" :class="{ 'is-invalid': form.errors.has('email') }" name="email" placeholder="Enter your email address" required autocomplete="email" :autofocus="!hasEmail">

                <button-component :busy="form.busy" :label="(form.successful) ? 'Resend Link' : 'Reset Password'" :label-loading="'Please wait...'" :button-class="'btn btn-default mg-sm-l-10 mg-t-10 mg-sm-t-0'"></button-component>
            </div>
            <has-error :form="form" field="email" :class="{ 'd-block': form.errors.has('email') }"></has-error>
        </form>
    </div>
</template>

<script>
	import authentication from "../../../mixins/authentication";
	import padlock from '../../../../img/padlock.svg';

	export default {
		mixins: [authentication],
		data() {
			return {
				padlock,
				form: new Form({
					email: null
				})
			};
		},
		computed: {
			hasEmail: function() {
				const email = _.keys(this.$route.query)[0];

				if (this.isValidEmail(email)) {
					this.form.email = email;
				}

				return this.isValidEmail(email);
			}
		},
		methods: {
			sendEmail() {
				this.form.post("/password/email");
			}
		}
	};
</script>
